namespace $ {

	export type $shm_hitalama_map_summary_data = {
		title: string
		changed_at: number
		created_at: number
		access_level: string
	}

	type Bottom_quick_access_item = {
		id: string,
		fullscreen?: boolean,
	}

	// Named link types keep declaration emit from expanding the recursive map/widget graph twice.
	export class $shm_hitalama_profile_maps_list extends $giper_baza_list_link.to( ()=> $shm_hitalama_map ) {}
	export class $shm_hitalama_profile_maps_link extends $giper_baza_atom_link.to( ()=> $shm_hitalama_profile_maps_list ) {}

	class $shm_hitalama_profile_home extends $giper_baza_flex_subj.with({
		Hitalama_profile: $giper_baza_atom_link.to( ()=> $shm_hitalama_profile ),
	}) {
		
	}

	class $shm_hitalama_profile_jsons_store extends $giper_baza_dict_to(
		$giper_baza_atom_link_to( ()=> $giper_baza_atom_dict )
	) {

	}

	class $shm_hitalama_profile_jsons extends $giper_baza_atom_link_to(
		()=> $shm_hitalama_profile_jsons_store
	) {

	}

	export class $shm_hitalama_profile extends $giper_baza_entity.with({

		Secrets: $giper_baza_atom_link.to( ()=> $giper_baza_atom_dict ),
		Map_access_outbox: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_access_outbox ),
		Avatar: $giper_baza_atom_link.to( ()=> $shm_hitalama_file ),
		Map_summaries: $giper_baza_atom_dict,
		Map_summary_items: $giper_baza_dict_to( $giper_baza_atom_dict ),

		Tokens: $giper_baza_list_link.to( ()=> $shm_hitalama_vk_token ),
		Groups_lists: $giper_baza_list_link.to( ()=> $shm_hitalama_vk_list ),

		Projects: $giper_baza_list_link.to( ()=> $shm_hitalama_project ),
		Maps: $shm_hitalama_profile_maps_link,
		Map_projects: $shm_hitalama_map_project_list_link,

		Maps_removed: $shm_hitalama_profile_maps_link,
		Templates_js: $giper_baza_atom_link.to( ()=> $shm_hitalama_map ),
		Templates_tsx: $giper_baza_atom_link.to( ()=> $shm_hitalama_map ),
		Templates_sql: $giper_baza_atom_link.to( ()=> $shm_hitalama_map ),
		Templates_commands: $giper_baza_atom_link.to( ()=> $shm_hitalama_map ),
		Overlayed_map: $giper_baza_atom_link.to( ()=> $shm_hitalama_map ),
		Overlayed_map_enabled: $giper_baza_atom_bool,
		Touch_hints_enabled: $giper_baza_atom_bool,

		Login: $giper_baza_atom_text,
		Pass_key: $giper_baza_atom_text,
		Version: $giper_baza_atom_real,

		Extension_current: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget ),

		Maps_sort_order: $giper_baza_atom_text,
		Maps_sort_by: $giper_baza_atom_text,

		Agent_chat_room: $giper_baza_atom_link.to( ()=> $shm_hitalama_chat_room ),
		Agent_chat_options: $giper_baza_atom_link.to( ()=> $shm_hitalama_chat_room_personal ),

		Used_tags: $giper_baza_list_str,

		Bottom_quick_access_items: $giper_baza_atom_list,
		Bottom_quick_access_ordered: $giper_baza_list_str,

		Jsons: $shm_hitalama_profile_jsons,

	}){

		private map_summary_normalize( id: string, value: any ): $shm_hitalama_map_summary_data | null {
			if( !value || typeof value !== 'object' || Array.isArray( value ) ) return null
			return {
				title: typeof value.title === 'string' ? value.title : id,
				changed_at: Number.isFinite( value.changed_at ) ? value.changed_at : 0,
				created_at: Number.isFinite( value.created_at ) ? value.created_at : 0,
				access_level: typeof value.access_level === 'string' ? value.access_level : '',
			}
		}

		@ $mol_mem
		map_summaries_legacy() {
			const raw = this.Map_summaries()?.val()
			if( !raw || typeof raw !== 'object' || Array.isArray( raw ) ) return {}
			return raw as Readonly< Record< string, $shm_hitalama_map_summary_data > >
		}

		@ $mol_mem
		map_summaries() {
			const summaries: Record< string, $shm_hitalama_map_summary_data > = {}
			for( const [ id, value ] of Object.entries( this.map_summaries_legacy() ) ) {
				const normalized = this.map_summary_normalize( id, value )
				if( normalized ) summaries[ id ] = normalized
			}

			const items = this.Map_summary_items()
			for( const key of items?.keys() ?? [] ) {
				if( typeof key !== 'string' ) continue
				const normalized = this.map_summary_normalize( key, items?.key( key )?.val() )
				if( normalized ) summaries[ key ] = normalized
			}
			return summaries as Readonly< Record< string, $shm_hitalama_map_summary_data > >
		}

		@ $mol_action
		map_summaries_upgrade() {
			const legacy = this.map_summaries_legacy()
			const items = this.Map_summary_items() ?? this.Map_summary_items( null )
			if( !items ) return 0

			let count = 0
			for( const [ id, value ] of Object.entries( legacy ) ) {
				if( items.key( id ) ) continue
				const normalized = this.map_summary_normalize( id, value )
				if( !normalized ) continue
				items.key( id, 'auto' )?.val( normalized )
				++ count
			}
			return count
		}

		@ $mol_mem_key
		map_summary( id: string, next?: $shm_hitalama_map_summary_data | null ) {
			if( next === undefined ) {
				const current = this.Map_summary_items()?.key( id )?.val()
				return this.map_summary_normalize( id, current ?? this.map_summaries_legacy()[ id ] )
			}

			const current_raw = this.Map_summary_items()?.key( id )?.val()
			const current = this.map_summary_normalize( id, current_raw ?? this.map_summaries_legacy()[ id ] )
			if( next && current_raw && current
				&& current.title === next.title
				&& current.changed_at === next.changed_at
				&& current.created_at === next.created_at
				&& current.access_level === next.access_level ) return next

			const items = this.Map_summary_items() ?? this.Map_summary_items( null )
			if( next ) items?.key( id, 'auto' )?.val( next )
			else items?.has( id, false )
			return next
		}

		static home() {
			return this.$.$giper_baza_glob!.home().cast($shm_hitalama_profile_home)
		}

		/** Public profile name of another client, when its home is readable. */
		static user_name( id: string ) {
			if( !id ) return ''
			if( id === this.$.$giper_baza_auth.current().pass().lord().str ) {
				return this.current()?.Login()?.val() ?? ''
			}
			const published = this.$.$mol_error_fence(
				()=> this.$.$shm_hitalama_domain.instance().team_catalog_current()
					?.User_names()?.key( id )?.val() ?? '',
				()=> '',
			)
			if( published ) return published
			return this.$.$mol_error_fence(
				()=> this.$.$giper_baza_glob.Land( new this.$.$giper_baza_link( id ) )
					.Data( this.$.$giper_baza_flex_subj ).cast( $shm_hitalama_profile_home )
					.Hitalama_profile()?.remote()?.Login()?.val() ?? '',
				()=> '',
			)
		}

		static user_avatar( id: string ) {
			if( !id ) return null
			if( id === this.$.$giper_baza_auth.current().pass().lord().str ) {
				return this.current()?.Avatar()?.remote() ?? null
			}
			return this.$.$mol_error_fence(
				()=> this.$.$shm_hitalama_domain.instance().team_catalog_current()
					?.User_avatars()?.key( id )?.remote() ?? null,
				()=> null,
			)
		}

		/** Public avatar link without opening the file land. */
		static user_avatar_link( id: string ) {
			if( !id ) return ''
			if( id === this.$.$giper_baza_auth.current().pass().lord().str ) {
				return this.current()?.Avatar()?.val()?.str ?? ''
			}
			return this.$.$mol_error_fence(
				()=> this.$.$shm_hitalama_domain.instance().team_catalog_current()
					?.User_avatars()?.key( id )?.val()?.str ?? '',
				()=> '',
			)
		}

		static avatar_uri( avatar: $shm_hitalama_file | null | undefined ) {
			return avatar ? $mol_wire_sync( avatar ).blob_uri_async() ?? '' : ''
		}

		@ $mol_mem_key
		static avatar_uri_by_link( link: string ) {
			return link ? this.avatar_uri( this.$.$giper_baza_glob.Pawn(
				new this.$.$giper_baza_link( link ), this.$.$shm_hitalama_file,
			) ) : ''
		}

		@ $mol_mem_key
		static user_avatar_uri( id: string ) {
			return this.avatar_uri( this.user_avatar( id ) )
		}

		static user_name_publish() {
			const name = this.current()?.Login()?.val()?.trim()
			if( !name ) return
			const id = this.$.$giper_baza_auth.current().pass().lord().str
			const catalog = this.$.$shm_hitalama_domain.instance().team_catalog_current()
			if( !catalog ) return
			const names = catalog.User_names() ?? catalog.User_names( null )
			const entry = names?.key( id ) ?? names?.key( id, 'auto' )
			if( entry && entry.val() !== name ) entry.val( name )

			const avatar = this.current()?.Avatar()?.remote() ?? null
			const avatars = catalog.User_avatars() ?? catalog.User_avatars( null )
			const avatar_entry = avatars?.key( id ) ?? avatars?.key( id, 'auto' )
			if( avatar_entry?.remote()?.link().str !== avatar?.link().str ) avatar_entry?.remote( avatar )
		}

		@ $mol_mem
		static current() {
			return $shm_hitalama_profile_migration.resolve_current(
				()=> this.home().Hitalama_profile()?.remote(),
			)
		}

		touch_hints_enabled( next?: boolean ): boolean {
			if( next !== undefined ) {
				this.Touch_hints_enabled( null )!.val( next )
				return next
			}
			this.$.$shm_hitalama_map_component_ready.read( this )
			const atom = this.Touch_hints_enabled()
			if( atom ) this.$.$shm_hitalama_map_component_ready.read( atom )
			return atom?.val() ?? true
		}

		@ $mol_action
		password( password: string ) {
			const auth = this.$.$giper_baza_auth.current()
			const pass_key = $mol_wire_sync( this.$.$shm_hitalama_profile_key ).export(
				auth.toString() + auth.toStringPrivate(), 
				password,
				this.Login()?.val()! 
			)
			
			this.Pass_key(null)!.val( pass_key )
		}

		@ $mol_mem_key
		auth_key_decrypt( password: string ) {

			const pass_key = this.Pass_key()?.val()!
			if( !pass_key ) return null

			const auth_key = $mol_wire_sync( $shm_hitalama_profile_key ).import( pass_key!, password )
			if( !auth_key ) return null

			return auth_key

		}

		@ $mol_action
		enter( password: string ) {
			const key = this.auth_key_decrypt( password )
			if( !key ) return false

			this.$.$giper_baza_auth.current( this.$.$giper_baza_auth.from( key ) )

			const home = this.$.$giper_baza_glob!.home().cast( $shm_hitalama_profile_home )
			home.Hitalama_profile(null)!.remote( this )
			return true
		}
		
		jsons() {
			// `ensure` is deterministic for an absent pointer and therefore safe across
			// wire restarts; a malformed slot fails instead of losing all settings.
			const unit = this.find( 'Jsons' )
			if( unit && unit.tag() !== $shm_hitalama_profile_jsons.tag ) {
				throw new Error( 'Не удалось открыть хранилище профиля' )
			}
			let slot = this.Jsons()
			if( !slot && unit ) {
				throw new Error( 'Не удалось открыть хранилище профиля' )
			}
			slot ??= this.Jsons( null )
			const current = slot?.remote() ?? slot?.ensure( this.land() )
			if( !current || typeof current.key !== 'function' ) {
				throw new Error( 'Не удалось открыть хранилище профиля' )
			}
			return current
		}

		store( key: string, data?: any ) {
			const jsons = this.jsons()
			const unit = jsons.find( key )
			if( unit && unit.tag() !== $giper_baza_atom_link.tag ) {
				throw new Error( `Не удалось открыть настройку профиля «${ key }»` )
			}
			if( data === undefined ) return jsons.key( key )?.remote()?.val()
			let slot = jsons.key( key )
			if( !slot && unit ) {
				throw new Error( `Не удалось открыть настройку профиля «${ key }»` )
			}
			slot ??= jsons.key( key, 'auto' )
			const store = slot?.remote() ?? slot?.ensure( this.land() )
			if( !store ) throw new Error( `Не удалось открыть настройку профиля «${ key }»` )
			return store.val( data ) ?? null
		}

		store_patch( key: string, data_patch: any ) {
			return this.store( key, { ... ( this.store( key ) ?? {} ), ... data_patch } )
		}

		used_tags( next?: string[] ) {
			return (this.Used_tags(next)?.items( next ) ?? []) as string[]
		}

		bottom_quick_access_ordered( next?: string[] ) {
			return (this.Bottom_quick_access_ordered(next)?.items( next ) ?? []) as string[]
		}
		bottom_quick_access_new_add( id: string ) {
			const cur = this.bottom_quick_access_items()
			if( cur.find( it => it.id == id ) ) return
			const next = [ ...cur, { id, fullscreen: true } ]
			this.bottom_quick_access_items( next )
			this.bottom_quick_access_ordered([...this.bottom_quick_access_ordered(),id])
		}
		bottom_quick_access_ordered_remove( id: string ) {
			this.bottom_quick_access_item_remove( id )
			this.bottom_quick_access_ordered(this.bottom_quick_access_ordered().filter( i => i != id ))
		}

		bottom_quick_access_items( next?: Bottom_quick_access_item[] ) {
			return (this.Bottom_quick_access_items(next)?.val( next ) ?? []) as Bottom_quick_access_item[]
		}
		bottom_quick_access_item_push( id: string ) {
			const cur = this.bottom_quick_access_items()
			if( cur.find( it => it.id == id ) ) return
			const next = [ ...cur, { id, fullscreen: true } ]
			this.bottom_quick_access_items( next )
		}
		bottom_quick_access_item_remove( id: string ) {
			this.bottom_quick_access_items( [
				...(this.bottom_quick_access_items()??[]).filter( it => it.id != id )
			] )
		}

		@ $mol_action
		used_tags_add( tag: string ) {
			this.used_tags( [ tag, ...this.used_tags() ] )
		}

		@ $mol_mem
		agent_chat_room() {
			return this.Agent_chat_room(null)?.ensure( [[ null, $giper_baza_rank_deny ]] )!
		}

		@ $mol_action
		map_access_outbox_ensure() {
			const outbox = this.Map_access_outbox( null )?.ensure( [[ null, $giper_baza_rank_deny ]] )
			if( !outbox || outbox.land().lord_rank( null ) >= $giper_baza_rank_read
				|| outbox.land().lord_rank( outbox.land().auth().pass().lord() ) < $giper_baza_rank_rule ) {
				$mol_fail( new Error( 'Не удалось открыть закрытую очередь приглашений' ) )
			}
			return outbox
		}

		@ $mol_mem
		agent_chat_options() {
			return this.Agent_chat_options(null)?.ensure( [[ null, $giper_baza_rank_deny ]] )!
		}

		agent_map_draft( map_id: string, next?: string ) {
			return this.agent_chat_options().agent_map_draft( map_id, next )
		}

		@ $mol_mem
		secrets( next?: any ) {
			return this.Secrets(null)?.ensure( [[ null, $giper_baza_rank_deny ]] )?.val( next ) ?? {}
		}

		@ $mol_mem_key
		secret_val( key: string, next?: string ){
			if( next !== undefined ) {
				this.secrets({ ... this.secrets(), [ key ]: next })
				return next
			}
			return (this.secrets() as any)[key] ?? ''
		}

		@ $mol_action
		add_map( title: string, access_level: keyof ReturnType<typeof $shm_hitalama_map.access_level_to_ranks> ) {
			const map = this.$.$shm_hitalama_map.make_new( title, access_level )
			this.Maps_list(null)?.add( map.link() )
			this.map_summary( map.link().str, map.summary() )
			return map
		}

		@ $mol_action
		template_map_make(
			title: string,
			widget_type: $shm_hitalama_map_widget_def_type_name,
			templates: readonly { title: string, code: string }[],
		) {
			return $shm_hitalama_map_templates.make_map( title, widget_type, templates )
		}

		templates_js() {
			let map = this.Templates_js(null)?.remote()
			if( map?.can_change() ) {
				if( !this.template_map_filled( map ) ) return map
				return $shm_hitalama_map_templates.fqn_actual( map )
			}

			map = $shm_hitalama_map_templates.import_js()
			this.Templates_js(null)?.remote( map )
			return $shm_hitalama_map_templates.fqn_actual( map )
		}

		templates_tsx() {
			let map = this.Templates_tsx(null)?.remote()
			if( map?.can_change() ) return map

			map = $shm_hitalama_map_templates.import_tsx()
			this.Templates_tsx(null)?.remote( map )
			return map
		}

		templates_sql() {
			let map = this.Templates_sql(null)?.remote()
			if( map?.can_change() ) return map

			map = $shm_hitalama_map_templates.import_sql()
			this.Templates_sql(null)?.remote( map )
			return map
		}

		template_map_filled( map: $shm_hitalama_map | null | undefined ) {
			const first = map?.Widgets_list()?.remote_list()[0]
			if( !first ) return false
			return Boolean( first.text() ) && first.right_edge_x() > 0 && first.bottom_edge_y() > 0
		}

		templates_commands() {
			let map = this.Templates_commands(null)?.remote()
			if( map?.can_change() ) {
				const actual = $shm_hitalama_map_templates.commands_actual( map )
				if( actual !== map ) this.Templates_commands(null)?.remote( actual )
				return actual
			}

			map = $shm_hitalama_map_templates.import_commands()
			this.Templates_commands(null)?.remote( map )
			return map
		}

		@ $mol_action
		selfhosted_defaults_ensure() {
			this.templates_js()
			this.templates_tsx()
			this.templates_sql()
			this.templates_commands()
			this.overlayed_map()
		}

		@ $mol_mem
		overlayed_map() {
			let map = this.Overlayed_map(null)?.remote()
			if( map?.can_change() && typeof map.deserialize === 'function' ) return $shm_hitalama_map_templates.overlayed_update( map )

			map = $shm_hitalama_map_templates.import_overlayed()
			this.Overlayed_map(null)?.remote( map )
			return map
		}

		overlayed_map_enabled( next?: boolean ) {
			return this.Overlayed_map_enabled(next)?.val( next ) ?? false
		}

		Maps_list(auto?: null) {
			const unit = this.find( 'Maps' )
			if( unit && unit.tag() !== $giper_baza_atom_link.tag ) {
				throw new Error( 'Не удалось открыть список карт профиля' )
			}
			let slot = this.Maps()
			if( !slot && unit ) {
				throw new Error( 'Не удалось открыть список карт профиля' )
			}
			slot ??= this.Maps( null )
			const list = slot?.remote() ?? slot?.ensure( this.land() )
			if( list && typeof ( list as any ).remote_list === 'function' ) return list

			throw new Error( 'Не удалось открыть список карт профиля' )
		}

		Map_projects_list( auto?: null ) {
			const unit = this.find( 'Map_projects' )
			if( unit && unit.tag() !== $giper_baza_atom_link.tag ) {
				throw new Error( 'Не удалось открыть список проектов карт профиля' )
			}
			let slot = this.Map_projects()
			if( !slot && unit ) {
				throw new Error( 'Не удалось открыть список проектов карт профиля' )
			}
			slot ??= this.Map_projects( auto )
			const list = slot?.remote() ?? slot?.ensure( this.land() )
			if( list && typeof ( list as any ).remote_list === 'function' ) return list

			throw new Error( 'Не удалось открыть список проектов карт профиля' )
		}

		@ $mol_action
		add_map_project( title: string ) {
			const project = this.$.$shm_hitalama_map_project.make_new( title )
			this.Map_projects_list( null ).splice([ project.link() ])
			return project
		}

		Maps_removed_list(auto?: null) {
			const unit = this.find( 'Maps_removed' )
			if( unit && unit.tag() !== $giper_baza_atom_link.tag ) {
				throw new Error( 'Не удалось открыть список удалённых карт профиля' )
			}
			let slot = this.Maps_removed()
			if( !slot && unit ) {
				throw new Error( 'Не удалось открыть список удалённых карт профиля' )
			}
			slot ??= this.Maps_removed( null )
			const list = slot?.remote() ?? slot?.ensure( this.land() )
			if( list && typeof ( list as any ).remote_list === 'function' ) return list

			throw new Error( 'Не удалось открыть список удалённых карт профиля' )
		}

		version( next?: number ) {
			return this.Version( next )?.val( next ) ?? 0
		}

		@ $mol_action
		cut_map( ref: $giper_baza_link ) {
			this.Maps_removed_list(null)?.add( ref )
			this.Maps_list(null)?.cut( ref )
			this.cut_template_map( ref )
		}

		@ $mol_action
		cut_template_map( ref: $giper_baza_link ) {
			const template_slots = [
				this.Templates_js(null),
				this.Templates_tsx(null),
				this.Templates_sql(null),
				this.Templates_commands(null),
				this.Overlayed_map(null),
			]

			for( const slot of template_slots ) {
				if( !slot ) continue
				if( slot.remote()?.link().toString() !== ref.toString() ) continue
				slot.remote( null )
			}
		}
		
	}
	
	/** @deprecated Use profile home/key auth instead. */
	export class $shm_hitalama_profile_dict extends $giper_baza_dict_to( $giper_baza_atom_link.to( ()=> $shm_hitalama_profile ) ) {
		
	}

}
